import {PORTAL_API_STORE_NAME} from '../reducers/reducers'

export function getPortalApiConfig(state) {
    const stored = state[PORTAL_API_STORE_NAME] || { }
    return stored.portalApiConfig
}
